export const isOnLine = process.env.NODE_ENV === 'production'
export const isLocal = false

export const urlConfig = {
  dev: 'https://api.fat.laodao.co',   //http://192.168.24.22:12004  https://api.fat.laodao.co
  pro: 'https://apis.box.laodao.co'
}

export const projectName = 'goodsmanual'

export const onlineOssInfo = {
  region: 'oss-cn-shanghai',
  accessKeyId: 'LTAIufO1A3SGZZ5t',
  accessKeySecret: 'sD83aWrXq89HmNgwpCbrGhDWKGDsia',
  bucket: 'service-center-image',
  severurl: 'service-center-image.oss-cn-shanghai.aliyuncs.com',
  url: 'image.laodao.so'
}

export const underlineOssInfo = {
  region: 'oss-cn-qingdao',
  accessKeyId: 'LTAIduij3bFJxU5P',
  accessKeySecret: 'Onih3CvVSCUVsEagRpHJjtpqI7VcxA',
  bucket: 'service-center',
  severurl: 'service-center.oss-cn-qingdao.aliyuncs.com',
  url: 'image.test.laodao.so'
}

export const videoOnlineOssInfo = {
  region: 'oss-cn-shanghai',
  accessKeyId: 'LTAIufO1A3SGZZ5t',
  accessKeySecret: 'sD83aWrXq89HmNgwpCbrGhDWKGDsia',
  bucket: 'service-center-video',
  severurl: 'service-center-video.oss-cn-shanghai.aliyuncs.com',
  url: 'video.laodao.so'
}
export const videoUnderlineOssInfo = {
  region: 'oss-cn-qingdao',
  accessKeyId: 'LTAIs3oSm15PNQLQ',
  accessKeySecret: 'CqooofLcKftoaqN5wrgYxOru1DB7nE',
  bucket: 'service-center-video-test',
  severurl: 'service-center-video-test.oss-cn-qingdao.aliyuncs.com',
  url: 'video.test.laodao.co'
}

export const fileOnlineOssInfo = {
  region: 'oss-cn-shanghai',
  accessKeyId: 'LTAIufO1A3SGZZ5t',
  accessKeySecret: 'sD83aWrXq89HmNgwpCbrGhDWKGDsia',
  bucket: 'service-center-file',
  severurl: 'service-center-video.oss-cn-shanghai.aliyuncs.com',
  url: 'file.laodao.so'
}
export const fileUnderlineOssInfo = {
  region: 'oss-cn-qingdao',
  accessKeyId: 'LTAIduij3bFJxU5P',
  accessKeySecret: 'Onih3CvVSCUVsEagRpHJjtpqI7VcxA',
  bucket: 'service-center',
  severurl: 'service-center.oss-cn-qingdao.aliyuncs.com',
  url: 'image.test.laodao.so'
}

/**
 * 图片
 */
export const onlineImageOssInfo = {
  region: 'oss-cn-shanghai',
  accessKeyId: 'LTAIufO1A3SGZZ5t',
  accessKeySecret: 'sD83aWrXq89HmNgwpCbrGhDWKGDsia',
  bucket: 'service-center-image',
  severurl: 'service-center-image.oss-cn-shanghai.aliyuncs.com',
  url: 'image.laodao.so'
}

export const underlineImageOssInfo = {
  region: 'oss-cn-qingdao',
  accessKeyId: 'LTAIduij3bFJxU5P',
  accessKeySecret: 'Onih3CvVSCUVsEagRpHJjtpqI7VcxA',
  bucket: 'service-center',
  severurl: 'service-center.oss-cn-qingdao.aliyuncs.com',
  url: 'image.test.laodao.so'
}
/**
 * 视频
 */
export const onlineVideoOssInfo = {
  region: 'oss-cn-shanghai',
  accessKeyId: 'LTAIufO1A3SGZZ5t',
  accessKeySecret: 'sD83aWrXq89HmNgwpCbrGhDWKGDsia',
  bucket: 'service-center-video',
  severurl: 'service-center-video.oss-cn-shanghai.aliyuncs.com',
  url: 'video.laodao.so'
}

export const underlineVideoOssInfo = {
  region: 'oss-cn-qingdao',
  accessKeyId: 'LTAIs3oSm15PNQLQ',
  accessKeySecret: 'CqooofLcKftoaqN5wrgYxOru1DB7nE',
  bucket: 'service-center-video-test',
  severurl: 'service-center-video-test.oss-cn-qingdao.aliyuncs.com',
  url: 'video.test.laodao.co'
}
/**
 * 音频
 */
export const onlineAudioOssInfo = {
  region: 'oss-cn-shanghai',
  accessKeyId: 'LTAIufO1A3SGZZ5t',
  accessKeySecret: 'sD83aWrXq89HmNgwpCbrGhDWKGDsia',
  bucket: 'service-center-audio',
  severurl: 'service-center-audio.oss-cn-shanghai.aliyuncs.com',
  url: 'audio.laodao.so'
}

export const underlineAudioOssInfo = {
  region: 'oss-cn-qingdao',
  accessKeyId: 'LTAIduij3bFJxU5P',
  accessKeySecret: 'Onih3CvVSCUVsEagRpHJjtpqI7VcxA',
  bucket: 'service-center',
  severurl: 'service-center.oss-cn-qingdao.aliyuncs.com',
  url: 'image.test.laodao.so'
}
/**
 * 文件
 */
export const onlineFileOssInfo = {
  region: 'oss-cn-shanghai',
  accessKeyId: 'LTAIufO1A3SGZZ5t',
  accessKeySecret: 'sD83aWrXq89HmNgwpCbrGhDWKGDsia',
  bucket: 'service-center-file',
  severurl: 'service-center-file.oss-cn-shanghai.aliyuncs.com',
  url: 'file.laodao.so'
}

export const underlineFileOssInfo = {
  region: 'oss-cn-qingdao',
  accessKeyId: 'LTAIduij3bFJxU5P',
  accessKeySecret: 'Onih3CvVSCUVsEagRpHJjtpqI7VcxA',
  bucket: 'service-center',
  severurl: 'service-center.oss-cn-qingdao.aliyuncs.com',
  url: 'image.test.laodao.so'
}
export default {
  baseUrl: isOnLine ? urlConfig.pro : urlConfig.dev,
  cookieExpires: 10,
  appKey: '5b3af39149188559bf158d4914e3123d', //1275d07bc8bd4ebb84e4dca046f56688    9f81ba0bc4264c0495fc87a9a2a2a312
  requestSource: 1,
  region: isOnLine ? onlineOssInfo.region : underlineOssInfo.region,
  accessKeyId: isOnLine ? onlineOssInfo.accessKeyId : underlineOssInfo.accessKeyId,
  accessKeySecret: isOnLine ? onlineOssInfo.accessKeySecret : underlineOssInfo.accessKeySecret,
  bucket: isOnLine ? onlineOssInfo.bucket : underlineOssInfo.bucket,

  videoregion: isOnLine ? videoOnlineOssInfo.region : videoUnderlineOssInfo.region,
  videoaccessKeyId: isOnLine ? videoOnlineOssInfo.accessKeyId : videoUnderlineOssInfo.accessKeyId,
  videoaccessKeySecret: isOnLine ? videoOnlineOssInfo.accessKeySecret : videoUnderlineOssInfo.accessKeySecret,
  videobucket: isOnLine ? videoOnlineOssInfo.bucket : videoUnderlineOssInfo.bucket,

  fileregion: isOnLine ? fileOnlineOssInfo.region : fileUnderlineOssInfo.region,
  fileaccessKeyId: isOnLine ? fileOnlineOssInfo.accessKeyId : fileUnderlineOssInfo.accessKeyId,
  fileaccessKeySecret: isOnLine ? fileOnlineOssInfo.accessKeySecret : fileUnderlineOssInfo.accessKeySecret,
  filebucket: isOnLine ? fileOnlineOssInfo.bucket : fileUnderlineOssInfo.bucket,

  audioregion: isOnLine ? onlineAudioOssInfo.region : underlineAudioOssInfo.region,
  audioaccessKeyId: isOnLine ? onlineAudioOssInfo.accessKeyId : underlineAudioOssInfo.accessKeyId,
  audioaccessKeySecret: isOnLine ? onlineAudioOssInfo.accessKeySecret : underlineAudioOssInfo.accessKeySecret,
  audiobucket: isOnLine ? onlineAudioOssInfo.bucket : underlineAudioOssInfo.bucket,

  imageOssInfo: isOnLine ? onlineImageOssInfo : underlineImageOssInfo,
  videoOssInfo: isOnLine ? onlineVideoOssInfo : underlineVideoOssInfo,
  audioOssInfo: isOnLine ? onlineAudioOssInfo : underlineAudioOssInfo,
  fileOssInfo: isOnLine ? onlineFileOssInfo : underlineFileOssInfo,
}

export const sConfig = {
  test: 'http://192.168.24.100:8080',
  local: 'http://s.fat.laodao.co',
  online: 'http://s.cfc99.com'
}

export const getSConfig = () => {
  if (isOnLine) {
    return sConfig.online
  } else if (isLocal) {
    return sConfig.local
  } else {
    return sConfig.test
  }
}
